import { render, staticRenderFns } from "./appltQrCode.vue?vue&type=template&id=335a582c&scoped=true"
import script from "./appltQrCode.vue?vue&type=script&lang=js"
export * from "./appltQrCode.vue?vue&type=script&lang=js"
import style0 from "./appltQrCode.vue?vue&type=style&index=0&id=335a582c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335a582c",
  null
  
)

export default component.exports